import {BaseLinkParams} from "../../../infrastructure/models/link/base-link-params";
import {ENTITY_TYPES} from "../../../core/app/consts";

export class CalculatorLinkParams extends BaseLinkParams  {
  entityType: ENTITY_TYPES;
  entityId: Number;

  constructor(entityType: ENTITY_TYPES, entityId: Number) {
    super();

    this.entityType = entityType;
    this.entityId = entityId;
  }

  get competitionId() {
    return this.entityType === ENTITY_TYPES.competition ? this.entityId : null
  }

  get competitorId() {
    return this.entityType === ENTITY_TYPES.team ? this.entityId : null;
  }

  get athleteId() {
    return this.entityType === ENTITY_TYPES.athlete ? this.entityId : null;
  }
}